import SideBarIcon from './SideBarIcon'
import { useTranslation } from 'react-i18next'
import { ActiveLink, IsListNotEmpty, toolTipAtrributes } from '@utils'
import { memo, useContext, useMemo } from 'react'
import { CRRender } from '@comp/crRender'
import { PrivilegeContext } from '@context/PrivilegesContext'

const DirectLink = ({ handleNavigate, screen, isMenuOpened = true }) => {
    const { t } = useTranslation()

    const { path, icon, name, id, children: childrenList } = useMemo(() => screen, [screen])
    const { authorizedPages } = useContext(PrivilegeContext)

    const isAllowedToBeRendered = useMemo(() =>
        id == 0 || (!IsListNotEmpty(childrenList) && !!authorizedPages?.find(p => id?.includes(p.id))?.id)
        , [id, path])


    return (
        <CRRender isRender={isAllowedToBeRendered}>
            <li key={name} onClick={() => handleNavigate(`/panel${path}`)} {...toolTipAtrributes(t(name), null, isMenuOpened)} >
                <div className={`menu ${ActiveLink(path)}`} >
                    <SideBarIcon icon={icon} />
                    <span className={`Item-name ${isMenuOpened ? "" : "d-none"}`}>{t(name)}</span>
                </div>
            </li>
        </CRRender>
    )
}

export default memo(DirectLink)